import { nullifyTransforms } from "./helpers"

export const handleDragFor = (flexyInstance, getState, setState) => {
  if (!flexyInstance.options.hasDragAndDrop) {
    return
  }

  const sliderContainer = flexyInstance.sliderContainer

  const handleDown = (e) => {
    if (!getState().sliderActivated) return

    if (
      flexyInstance.options.elementsThatDoNotStartDrag.reduce(
        (shouldSkipDrag, selector) =>
          shouldSkipDrag
            ? true
            : e.target.matches(selector) || e.target.closest(selector),

        false
      )
    ) {
      return
    }

    // e.preventDefault()
    e.stopPropagation()

    if (e.type !== "touchstart") {
      e.preventDefault()
    }

    flexyInstance.options.onDragStart(e)

    setState({
      ...getState(),
      startX: e.pageX || e.touches[0].pageX,
      endX: e.pageX || e.touches[0].pageX,
      mouseDown: true,
      downScrollPosition: {
        x: window.pageXOffset,
        y: window.pageYOffset,
      },
      positionSnapshot: getState().positionX,
    })

    const handleMouseUp = (e) => {
      if (!getState().mouseDown) return

      e.stopPropagation()

      setState({
        ...getState(),
        mouseDown: false,
      })

      document.removeEventListener("mousemove", handleMouseMove)
      document.removeEventListener("mouseup", handleMouseUp)

      document.removeEventListener("touchmove", handleMouseMove)
      document.removeEventListener("touchend", handleMouseUp)

      let state = getState()

      let fromPercentage =
        (state.positionX * 100) /
        nullifyTransforms(
          sliderContainer.firstElementChild,
          flexyInstance.options.nullifyTransformEl
        ).width

      setState({
        ...getState(),
        positionTarget:
          (nullifyTransforms(
            sliderContainer.firstElementChild,
            flexyInstance.options.nullifyTransformEl
          ).width *
            (Math.abs(state.endX - state.startX) > 50
              ? state.endX - state.startX < 0
                ? Math.floor(fromPercentage / 100) * 100
                : Math.ceil(fromPercentage / 100) * 100
              : Math.round(fromPercentage / 100) * 100)) /
          100,
      })
    }

    const handleMouseMove = (e) => {
      let { pageX: endX } = e

      if (!endX) {
        endX = e.touches[0].pageX
      }

      if (!getState().mouseDown) return

      let state = getState()

      let { startX, positionSnapshot } = state

      setState({
        ...state,
        endX,
      })

      if (
        Math.abs(state.downScrollPosition.x - state.scrollPosition.x) > 3 ||
        Math.abs(state.downScrollPosition.y - state.scrollPosition.y) > 5
      ) {
        handleMouseUp(e, false)
      }
    }

    document.addEventListener("mousemove", handleMouseMove)
    document.addEventListener("mouseup", handleMouseUp)

    document.addEventListener("touchmove", handleMouseMove, { passive: true })
    document.addEventListener("touchend", handleMouseUp, { passive: true })
  }

  sliderContainer.addEventListener("mousedown", handleDown, { passive: true })
  sliderContainer.addEventListener("touchstart", handleDown, { passive: true })

  if (
    flexyInstance.options.initialDragEvent &&
    !flexyInstance.options.initialDragEvent.target.closest(
      ".flexy-pills > * > *"
    )
  ) {
    requestAnimationFrame(() => {
      handleDown(flexyInstance.options.initialDragEvent)
    })
  }
}
